import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Grid,
  Image,
  GridItem,
} from "@chakra-ui/react";

const OurMission = () => {
  const missionItems = [
    {
      id: 1,
      title: "We EMPOWER Our Clients",
      description: "We go beyond software—we build capability.",
      details: [
        "Our platforms are designed to help governments and enterprises work smarter, respond faster, and serve better.",
        "With deep local insight and international standards, we deliver not just technology, but also the training, support, and confidence needed for long-term impact.",
      ],
      icon: "👥", // Icon representing empowerment
      position: "top", // Position in circular flow
    },
    {
      id: 2,
      title: "We INNOVATE with Purpose",
      description: "We believe innovation should solve real-world problems.",
      details: [
        "From national e-Governance systems to AI-powered automation, we combine technical excellence with human-centered design.",
        "Our continuous investment in R&D, machine learning, and emerging technologies ensures our clients stay future-ready in a rapidly evolving world.",
      ],
      icon: "💡", // Innovation bulb icon
      position: "bottom-left", // Position in circular flow
    },
    {
      id: 3,
      title: "We DELIVER Seamless Experiences",
      description: "Great technology should feel effortless.",
      details: [
        "That's why we design for performance, usability, and continuity—whether digitizing public services, automating enterprise workflows, or simplifying access through citizen-facing portals.",
        "Our systems are intuitive, responsive, and reliable—built to support real users in real time.",
      ],
      icon: "⚙️", // Gears icon
      position: "bottom-right", // Position in circular flow
    },
  ];

  return (
    <Box py={{ base: 4, md: 8 }} position="relative">
      <Container maxW="7xl">
        <VStack spacing={0} align="center">
          {/* Main Header */}
          {/* <Heading
            as="h2"
            fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
            fontWeight="bold"
            color="#000B8C"
            textAlign="center"
            mb={2}
          >
            Our Mission
          </Heading> */}
          <Heading
            as="h1"
            fontSize={{ base: "2xl", md: "4xl" }}
            fontWeight="bold"
            color="#000B8C"
            lineHeight="1.2"
          >
            Our{" "}
            <Text as="span" color="gray.700">
              Mission
            </Text>
          </Heading>

          <Text
            fontSize={{ base: "md", md: "lg" }}
            color="gray.500"
            fontStyle="italic"
            textAlign="center"
            mb={8}
          >
            Empower. Innovate. Deliver Experience.
          </Text>

          {/* Mission Statement */}
          <Text
            fontSize={{ base: "md", md: "lg" }}
            color="gray.600"
            textAlign="left"
            maxW="7xl"
            lineHeight="tall"
            mb={8}
          >
            At Business Automation Limited, our mission is to be Bangladesh's most
            trusted technology partner—empowering institutions, innovating with
            purpose, and delivering seamless digital experiences that improve
            lives.
          </Text>

          {/* Main Layout: Circular Diagram + Content */}
          <Grid
            templateColumns={{ base: "1fr", lg: "1fr 1.5fr" }}
            w="100%"
            maxW="7xl"
            alignItems="center"
          >
            {/* Left Side: Image Placeholder */}
            <GridItem>
              <Box
                h={{ base: "300px", md: "400px", lg: "460px" }}
                bg="gray.100"
                borderRadius="lg"
                border="2px dashed gray.400"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
              >
                {/* Add import: import { Image } from "@chakra-ui/react"; */}
                <Image
                  src="/png/blend.png"
                  alt="Mission flow diagram: Empower, Innovate, Deliver"
                  w="100%"
                  h="100%"
                  objectFit="cover"
                  borderRadius="lg"
                  fallbackSrc="https://via.placeholder.com/600x400?text=Mission+Flow"
                />
                {/* <Text
                      mt={4}
                      color="gray.500"
                      fontSize={{ base: "xs", md: "sm" }}
                      textAlign="center"
                      fontWeight="medium"
                    >
                      Empower • Innovate • Deliver
                    </Text> */}
              </Box>
            </GridItem>

            <GridItem>
              <VStack spacing={0} align="stretch">
                {missionItems.map((item, index) => (
                  <Box
                    key={item.id}
                    bg="white"
                    p={{ base: 4, md: 6 }}
                    borderRadius="lg"
                    boxShadow="md"
                    border="1px"
                    borderColor="gray.200"
                    borderTop="4px"
                    borderTopColor={
                      index === 0
                        ? "#4A90E2"
                        : index === 1
                        ? "#000B8C"
                        : "#8E44AD"
                    }
                  >
                    <VStack align="start" spacing={3}>
                      <Heading
                        as="h4"
                        fontSize={{ base: "md", md: "lg" }}
                        fontWeight="bold"
                        color="gray.800"
                      >
                        {item.title}
                      </Heading>

                      <Text
                        fontSize={{ base: "sm", md: "md" }}
                        color="gray.600"
                        fontWeight="medium"
                        fontStyle="italic"
                      >
                        {item.description}
                      </Text>

                      <VStack align="start" spacing={0}>
                        {item.details.map((detail, detailIndex) => (
                          <Text
                            key={detailIndex}
                            fontSize={{ base: "sm", md: "md" }}
                            color="gray.600"
                            lineHeight="1.3"
                            textAlign="justify"
                          >
                            {detail}
                          </Text>
                        ))}
                      </VStack>
                    </VStack>
                  </Box>
                ))}
              </VStack>
            </GridItem>
          </Grid>

          {/* Text below image */}
          <Text
            fontSize={{ base: "md", md: "lg" }}
            color="gray.600"
            lineHeight="1.2"
            textAlign="center"
            maxW="6xl"
            mx="auto"
            mt={4}
            fontStyle="normal"
          >
            As Bangladesh accelerates its digital journey, so do we. More than a
            vendor, we are a strategic enabler—offering co-created solutions
            through outsourced or managed service models that illustrate our
            commitment to excellence.
            <br />
            <br />
            Let's build that smarter, more connected future—together.
          </Text>
        </VStack>
      </Container>
    </Box>
  );
};

export default OurMission;
